import { call, put, takeEvery } from "redux-saga/effects";
import { paymentActions } from "../../store/payments/actions";
import { get } from "lodash";
import {
  PAYMENT_INTENT_REQUEST,
  PAYMENT_INTENT_SUCCESS,
  PREMIUM_PAYMENT_INTENT_REQUEST,
  PREMIUM_PAYMENT_INTENT_SUCCESS,
  PREMIUM_PAYMENT_SUCCESS,
  PAYMENT_SUCCESS,
  PAYMENT_FAILURE,
  COUPON_PAYMENT_INTENT_REQUEST,
  COUPON_PAYMENT_INTENT_SUCCESS,
  COUPON_PAYMENT_SUCCESS,
} from "../../constants/payments";
import {
  requestPaymentIntent,
  requestPremiumPaymentIntent,
  requestCouponPaymentIntent,
} from "../../api/payments";

import { toast } from "react-toastify";
import { meActions } from "../../store/me/actions";
//Tr
import i18n from "../../i18n";

const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

function* paymentSuccessSaga(action: any) {
  yield toast.success(`${i18n.t("translation:payment_success")}`);

  yield delay(2500);
  yield put(meActions.refreshWalletRequestAction());
}
function* premiumPaymentSuccessSaga(data: any) {
  const intent = data.payload.paymentIntent;
  const tipster_id = data.payload.tipster_id;

  yield toast.success(`${i18n.t("translation:payment_success")}`);

  if (intent) {
    yield delay(2500);
    yield put(meActions.getUserPremiumPlansRequestAction(tipster_id));
  }
}
function* couponPaymentSuccessSaga(action: any) {
  yield toast.success(`${i18n.t("translation:payment_success")}`);
}
function* paymentFailureSaga(action: any) {
  yield toast.error(
    `${i18n.t(action.payload.type)}: ${
      action.payload.code || action.payload.message
    }`
  );
}
function* paymentIntentRequestSaga(action: any): any {
  try {
    const secret = yield call(requestPaymentIntent, action.payload);
    yield put(paymentActions.paymentIntentSuccessAction(secret));
  } catch (e: any) {
    yield put(paymentActions.paymentIntentFailureAction(e));
    toast.error(i18n.t("translation:payment_error"));
  }
}
function* couponPaymentIntentRequestSaga(action: any): any {
  try {
    const secret = yield call(requestCouponPaymentIntent, action.payload);
    yield put(paymentActions.couponPaymentIntentSuccessAction(secret));
  } catch (e: any) {
    yield put(paymentActions.couponPaymentIntentFailureAction(e));
    toast.error(i18n.t("translation:payment_error"));
  }
}

function* couponPaymentIntentSuccessSaga(secret: any) {
  try {
    yield put(paymentActions.paymentRequestAction(secret.payload.purchase));
  } catch (e: any) {
    yield put(paymentActions.couponPaymentIntentFailureAction(e));
    toast.error(i18n.t("translation:payment_error"));
  }
}

function* premiumPaymentIntentRequestSaga(action: any): any {
  try {
    const secret = yield call(requestPremiumPaymentIntent, action.payload);
    yield put(paymentActions.premiumPaymentIntentSuccessAction(secret));
  } catch (e: any) {
    const detail = get(e, "detail");
    const message = get(e, "message");

    yield put(paymentActions.premiumPaymentIntentFailureAction(e));
    toast.error(i18n.t("translation:payment_error"));
    detail && toast.error(detail);
    message && toast.error(message);
  }
}
function* premiumPaymentIntentSuccessSaga(secret: any) {
  try {
    yield put(
      paymentActions.paymentRequestAction(secret.payload.premium_plan_purchase)
    );
  } catch (e: any) {
    yield put(paymentActions.premiumPaymentIntentFailureAction(e));
    toast.error(i18n.t("translation:payment_error"));
  }
}

function* paymentIntentSuccessSaga(secret: any) {
  try {
    yield put(
      paymentActions.paymentRequestAction(secret.payload.coins_pack_purchase)
    );
  } catch (e: any) {
    yield put(paymentActions.paymentIntentFailureAction(e));
    toast.error(i18n.t("translation:payment_error"));
  }
}

function* paymentsSaga() {
  yield takeEvery(PAYMENT_INTENT_REQUEST, paymentIntentRequestSaga);
  yield takeEvery(PAYMENT_INTENT_SUCCESS, paymentIntentSuccessSaga);
  yield takeEvery(
    PREMIUM_PAYMENT_INTENT_REQUEST,
    premiumPaymentIntentRequestSaga
  );
  yield takeEvery(
    PREMIUM_PAYMENT_INTENT_SUCCESS,
    premiumPaymentIntentSuccessSaga
  );
  yield takeEvery(PAYMENT_SUCCESS, paymentSuccessSaga);
  yield takeEvery(PREMIUM_PAYMENT_SUCCESS, premiumPaymentSuccessSaga);

  yield takeEvery(PAYMENT_FAILURE, paymentFailureSaga);
  yield takeEvery(
    COUPON_PAYMENT_INTENT_REQUEST,
    couponPaymentIntentRequestSaga
  );
  yield takeEvery(
    COUPON_PAYMENT_INTENT_SUCCESS,
    couponPaymentIntentSuccessSaga
  );
  yield takeEvery(COUPON_PAYMENT_SUCCESS, couponPaymentSuccessSaga);
}

export default paymentsSaga;
